import { GetTargetTabProps } from '@occc-app/offerHelpers/TargetForm/types';

import { getPromocodesOperations } from './promocodes-target.operations';
import { PromocodesTargetFormContainer } from './promocodes-target';

import { PromocodesTargetFormValues } from '../PromocodesConfiguration/promocodes-configuration.types';
import { validatePromocodes } from '../PromocodesConfiguration/promocodes-configuration.schema';

export const getPromocodesTargetTabProps: GetTargetTabProps = (offer) => ({
  tabLabel: 'Promo Codes + Target',
  shouldShowStateRestrictions: false,
  shouldShowStoreLocationOrGroups: false,
  shouldShowSubBrands: false,
  customSection: {
    render: (context) => <PromocodesTargetFormContainer {...context} offer={offer} />,
    getOperations: (offerId, currentOffer, values, dirtyFields) =>
      getPromocodesOperations(
        offerId,
        currentOffer ?? offer ?? undefined,
        values as unknown as PromocodesTargetFormValues,
        dirtyFields,
      ),
    getValidation: (values) => validatePromocodes(values as unknown as PromocodesTargetFormValues),
  },
});
